import React from 'react';
import { Image } from 'semantic-ui-react';
// @ts-ignore
import bronzeNugget from '../../icons/nuggets/bronze-nugget.svg';
// @ts-ignore
import goldNugget from '../../icons/nuggets/gold-nugget.svg';
// @ts-ignore
import silverNugget from '../../icons/nuggets/silver-nugget.svg';

type BadgeId = 1 | 2 | 3;

interface BadgeProps {
    badgeId: BadgeId | number;
}

const Badge: React.FC<BadgeProps> = ({ badgeId }) => {
    const nuggetMap: { [key in BadgeId]?: string } = {
        [3]: goldNugget,
        [2]: silverNugget,
        [1]: bronzeNugget,
    };

    const nuggetSrc = nuggetMap[badgeId as BadgeId];

    if (nuggetSrc) {
        return (
            <Image
                className="nugget-size"
                spaced="right"
                src={nuggetSrc}
                alt={
                    badgeId === 3
                        ? 'Gold Nugget Badge'
                        : badgeId === 2
                          ? 'Silver Nugget Badge'
                          : 'Bronze Nugget Badge'
                }
            />
        );
    }

    return null;
};

export default Badge;
